import React, { Component } from 'react';
import _ from 'lodash';
import Modal from 'react-modal';
import { toastr } from 'react-redux-toastr';

import RadioGroup from 'components/radioGroup/RadioGroup';
import Checkbox from 'components/checkbox/Checkbox';

import { addDivision } from 'util/pouchActions';
import { getBaseDivisions } from 'util/standardDivisions';
import {
  isLbsMeet,
} from 'util/meetHelper';
import {
  getRawOrEquippedOptions,
  getGenderOptions
} from 'util/options';

class GenerateModal extends Component {
  constructor(props) {
    super(props);
    const baseDivisionsChecks = {};
    const baseDivisions = getBaseDivisions(this.props.meet);
    _.each(baseDivisions, (div) => {
      if(div.default) {
        baseDivisionsChecks[div.name] = true;
      }
    });

    const equipmentLevels = {};
    _.each(getRawOrEquippedOptions(null, this.props.meet), (equipmentLevel) => {
      equipmentLevels[equipmentLevel.value] =  true;
    });

    if(equipmentLevels['RAW_WITH_WRAPS'] && this.props.meet.federation === "USAPL") {
      equipmentLevels['RAW_WITH_WRAPS'] = false;
    }

    const genders = {};
    _.each(getGenderOptions(null, this.props.meet), (gender) => {
      genders[gender.value] =  true;
    });

    this.state = {
      genders,
      equipmentLevel: equipmentLevels,
      baseDivisions: baseDivisionsChecks,
      lifts: 'POWERLIFTING'
    };
  }

  onCheck = (cat, id, value) => {
    this.setState({[cat]: {...this.state[cat], [id]: value}});
  }

  onRadioSelect = (value) => {
    if(value !== 'POWERLIFTING' && value !== 'SQUAT') {
      if(this.state.equipmentLevel['RAW_WITH_WRAPS']) {
        return this.setState({lifts: value, equipmentLevel: {...this.state.equipmentLevel, RAW_WITH_WRAPS: false}});
      }
    }

    if(value !== 'BENCH' && this.state.baseDivisions['Para Bench']) {
      return this.setState({lifts: value, baseDivisions: {...this.state.baseDivisions, 'Para Bench': false}});
    }

    this.setState({lifts: value});
  }

  getDivisionName = (meet, gender, equipmentLevel, baseDivisionName, liftNamePostFix) => {
    if(meet.federation === 'USSF') {
      return _.trim(`${gender === 'MALE' ? "Open" : "Women's"} ${baseDivisionName === 'Open' ? '' : baseDivisionName} ${liftNamePostFix}`);
    } else {
      const genderPrefixes = {
        MALE: "Men's",
        FEMALE: "Women's",
        MX: 'Mx'
      };

      if(baseDivisionName === 'Para Bench') {
        return _.trim(`${genderPrefixes[gender]} ${baseDivisionName}`);
      }

      return _.trim(`${genderPrefixes[gender]} ${_.startCase(_.toLower(equipmentLevel))} ${baseDivisionName} ${liftNamePostFix}`);
    }
  }

  generateDivisions = () => {
    let liftNamePostFix = '';
    const lifts = {
      squat: false,
      bench: false,
      dead: false
    };

    if(this.state.lifts === 'POWERLIFTING') {
      lifts.squat = true;
      lifts.bench = true;
      lifts.dead = true;
    } else if(this.state.lifts === 'PUSH_PULL') {
      lifts.bench = true;
      lifts.dead = true;
      liftNamePostFix = 'Push/Pull';
    } else if(this.state.lifts === 'SQUAT') {
      lifts.squat = true;
      liftNamePostFix = 'Squat Only';
    } else if(this.state.lifts === 'BENCH') {
      lifts.bench = true;
      liftNamePostFix = 'Bench Only';
    } else if(this.state.lifts === 'DEAD') {
      lifts.dead = true;
      liftNamePostFix = 'Deadlift Only';
    }

    const baseDivisions = getBaseDivisions(this.props.meet);
    let divisionCount = 0;
    let weightClassCount = 0;
    _.each(this.state.genders, (isGenderOn, gender) => {
      if(isGenderOn) {
        _.each(this.state.equipmentLevel, (isEquipmentLevelOn, equipmentLevel) => {
          if(isEquipmentLevelOn) {
            _.each(this.state.baseDivisions, (isBaseDivisionOn, baseDivisionName) => {
              if(baseDivisionName === 'Para Bench' && equipmentLevel !== 'RAW') {
                return;
              }

              if(isBaseDivisionOn) {
                const baseDivision = _.find(baseDivisions, {name: baseDivisionName});
                const weightClasses = {};
                const weightClassData = baseDivision.weightClasses[gender];

                _.each(weightClassData, (weightClass, index) => {
                  let newWeightClass = {};
                  if(isLbsMeet(this.props.meet)) {
                    newWeightClass = {name: weightClass.lbsName, maxWeight: weightClass.lbsMaxWeight};
                  } else {
                    newWeightClass = {name: weightClass.name, maxWeight: weightClass.maxWeight};
                  }
                  weightClasses[`w-${index}`] = newWeightClass;
                  weightClassCount++;
                });

                const newDivision = {
                  name: this.getDivisionName(this.props.meet, gender, equipmentLevel, baseDivisionName, liftNamePostFix),
                  lifts,
                  gender,
                  rawOrEquipped: equipmentLevel,
                  scoreBy: _.get(baseDivision, 'scoreBy', 'TOTAL'),
                  usaplDivisionCode: baseDivision.code,
                  weightClasses
                };
                addDivision(this.props.meet._id, newDivision);
                divisionCount++;
              }
            });
          }
        });
      }
    });

    this.props.onRequestClose();
    toastr.success(`Created ${divisionCount} new divisions and ${weightClassCount} weight classes`);
    this.props.onFinishBulkCreate(divisionCount);
  }

  render() {
    const { onRequestClose, isOpen, meet } = this.props;
    const baseDivisions = getBaseDivisions(meet);

    return (
      <Modal
        ariaHideApp={false}
        isOpen={isOpen}
        contentLabel="Generate Divisions"
        onRequestClose={onRequestClose}
        className={{
          base: 'generate-divisions-modal',
          afterOpen: 'generate-divisions-modal-after-open',
          beforeClose: 'generate-divisions-modal-before-close'
        }}
        overlayClassName={{
          base: 'generate-divisions-modal-overlay',
          afterOpen: 'generate-divisions-modal-overlay-after-open',
          beforeClose: 'generate-divisions-modal-overlay-before-close'
        }}
      >
        <div className="content">
          <div className="first-columns">
            { meet.federation !== 'USSF' &&
              <div className="column">
                <RadioGroup
                  onCheck={this.onRadioSelect}
                  value={this.state.lifts}
                  items={[
                    {label: 'Powerlifting', value: 'POWERLIFTING'},
                    {label: 'Push / Pull', value: 'PUSH_PULL'},
                    {label: 'Squat Only', value: 'SQUAT'},
                    {label: 'Bench Only', value: 'BENCH'},
                    {label: 'Deadlift Only', value: 'DEAD'}
                  ]}
                />
              </div>
            }
            <div className="column">
              {
                _.map(this.state.genders, (value, gender) => {
                  return (
                    <Checkbox key={gender} label={_.get(_.find(getGenderOptions(null, meet), {value: gender}), 'label')} value={this.state.genders[gender]} onCheck={(v)=> this.onCheck('genders', gender, v)} />
                  );
                })
              }
            </div>
            { (meet.federation !== 'USSF' && meet.federation !== '100RAW') &&
              <div className="column">
                {
                  _.map(this.state.equipmentLevel, (value, el) => {
                    const disabled = el === 'RAW_WITH_WRAPS' && (this.state.lifts !== 'POWERLIFTING' && this.state.lifts !== 'SQUAT');

                    return (
                      <Checkbox disabled={disabled} key={el} label={_.startCase(_.toLower(el))} value={this.state.equipmentLevel[el]} onCheck={(v)=> this.onCheck('equipmentLevel', el, v)} />
                    );
                  })
                }
              </div>
            }
          </div>
          <div className="column">
            {
              _.map(baseDivisions, (division) => {
                const disabled = division.code === 'PB' && this.state.lifts !== 'BENCH';

                return (
                  <Checkbox disabled={disabled} key={division.name} label={division.name} value={this.state.baseDivisions[division.name]} onCheck={(v)=> this.onCheck('baseDivisions', division.name, v)} />
                );
              })
            }
          </div>
        </div>
        <div className="button-row">
          <button onClick={onRequestClose} style={{marginRight: 12}}>Cancel</button>
          <button onClick={this.generateDivisions}>Generate</button>
        </div>
      </Modal>
    );
  }
}

export default GenerateModal;
